import React from "react";
import { BsStarFill, BsStarHalf, BsStar } from 'react-icons/bs'
import range from 'lodash/range';

interface RatingsProps extends React.HTMLProps<HTMLDivElement> {
	ratings: number;
}

export default function Ratings({ratings, ...others}: RatingsProps) {
	const solidStars = Math.floor(ratings / 20);
	const partialStar = ratings % 20 > 0;
	let emptyStars = 5 - solidStars;
	if (partialStar) {
		emptyStars--;
	}

	return <div {...others}>
		{range(0, solidStars).map((index) => (
			<BsStarFill key={`f-${index}`} />
		))}

		{partialStar && <BsStarHalf />}

		{range(0, emptyStars).map((index) => (
			<BsStar key={`e-${index}`} />
		))}
	</div>;
}
